import { ViewModel, View, ObservableArray } from "binder"
import { PeriodicWarehouseCheckUpForManagerView } from "./periodicWarehouseCheckUpForManager-view"
import { ExcelExporter, stringIsNullOrEmpty } from "src/common/utilities";
import { Converters } from "src/uicomponents/converters";
import { ServerConnection } from "src/server/serverConnection";
import { ServerSideDataLoader, PaginationInfo } from "uicomponents";
import { PersonnelSearchableSelectorViewModel, PersonnelSelectorViewModel } from "src/EnterpriseAdministration/personnelManipulation/personnelSelector";
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { CurrentDistrictWarehousesSelectorViewModel } from "../warehouseManipulation/warehouseManipulation-viewModel";
import moment from "moment";


export class PeriodicWarehouseCheckUpForManagerViewModel extends WindowViewModel {
    public getTitle(): string {
        return "بررسی دوره ای انبار - مدیر انبار";
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.endDateTime = moment(new Date());
        this.loader = new ServerSideDataLoader(filteringInformation => this.refreshPaged(filteringInformation), 30);
        this.warehouseCheckUps = ObservableArray.create<WarehouseCheckUp>();
        this.warehouseCheckUpOperators = ObservableArray.create<WarehouseCheckUpOperator>();
        this.personnelSelector = new PersonnelSelectorViewModel(this, false, null, false, true, false, false, false, false);
        this.warehouseSelector = new CurrentDistrictWarehousesSelectorViewModel(this, false, false, true, false, false);
        this.warehouseSelector.onSelectionChanged = async warehouse => {
            await this.createNewInstanceOfPersonnelSelector(warehouse.id);
        }

        this.updateWarehouseCheckUpOpertators();
        this.refresh();
    }
    GetDefaultView(): View<ViewModel> {
        return new PeriodicWarehouseCheckUpForManagerView();
    }
    public getTypeId(): string {
        return "VM-F9B22013-E55B-4C6D-AD63-705945681434"
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader; } private _loader: ServerSideDataLoader;
    public set warehouseCheckUps(v: ObservableArray<WarehouseCheckUp>) { this._warehouseCheckUps = v; } public get warehouseCheckUps(): ObservableArray<WarehouseCheckUp> { return this._warehouseCheckUps; } private _warehouseCheckUps: ObservableArray<WarehouseCheckUp>;
    public set startDateTime(v: moment.Moment) { this._startDateTime = v; } public get startDateTime(): moment.Moment { return this._startDateTime; } private _startDateTime: moment.Moment;
    public set endDateTime(v: moment.Moment) { this._endDateTime = v; } public get endDateTime(): moment.Moment { return this._endDateTime; } private _endDateTime: moment.Moment;
    public set warehouseCheckUpOperators(v: ObservableArray<WarehouseCheckUpOperator>) { this._warehouseCheckUpOperators = v; } public get warehouseCheckUpOperators(): ObservableArray<WarehouseCheckUpOperator> { return this._warehouseCheckUpOperators; } private _warehouseCheckUpOperators: ObservableArray<WarehouseCheckUpOperator>;
    public set personnelSelector(v: PersonnelSelectorViewModel) { this._personnelSelector = v; } public get personnelSelector(): PersonnelSelectorViewModel { return this._personnelSelector; } private _personnelSelector: PersonnelSelectorViewModel;
    public set warehouseSelector(v: CurrentDistrictWarehousesSelectorViewModel) { this._warehouseSelector = v; } public get warehouseSelector(): CurrentDistrictWarehousesSelectorViewModel { return this._warehouseSelector; } private _warehouseSelector: CurrentDistrictWarehousesSelectorViewModel;

    refresh() {
        this.loader.refresh();
    }

    async createNewInstanceOfPersonnelSelector(warehouseId: string) {
        this.personnelSelector = new PersonnelSelectorViewModel(this, false, warehouseId, false, true, false, false, false);
        this.personnelSelector.onSelectionChanged = async personnel => {
            let operator = new WarehouseCheckUpOperator(this);
            operator.personnelId = personnel.id;
            operator.personnelCode = personnel.code;
            operator.personnelFullName = personnel.name + " " + personnel.lastName;
            await operator.SetAsOperator();
        };
        this.personnelSelector.refresh();
    }

    async refreshPaged(filteringInformation: any): Promise<PaginationInfo> {
        try {
            this.isLoading = true;
            let serverResult = await ServerConnection.callServer("Complex/WarehouseServices/GetManagerWarehouseCheckUps", {
                FilteringInformation: filteringInformation
            });
            this.warehouseCheckUps.update(...serverResult.WarehouseCheckUps.map((checkUp, index) => {
                let warehouseCheckUp = new WarehouseCheckUp(this);
                warehouseCheckUp.index = index + 1;
                warehouseCheckUp.id = checkUp.Id;
                warehouseCheckUp.creationTime = checkUp.CreationTime;
                warehouseCheckUp.productName = checkUp.ProductName;
                warehouseCheckUp.productCode = checkUp.ProductCode;
                warehouseCheckUp.productIndex = checkUp.ProductIndex;
                warehouseCheckUp.carModelName = checkUp.CarModelName;
                warehouseCheckUp.brandName = checkUp.BrandName;
                warehouseCheckUp.countryName = checkUp.CountryName;
                warehouseCheckUp.warehouseName = checkUp.WarehouseName;
                warehouseCheckUp.balance = checkUp.Balance;
                warehouseCheckUp.newBalance = checkUp.NewBalance;
                warehouseCheckUp.colorName = checkUp.ColorName;
                warehouseCheckUp.status = checkUp.IsChecked == true ? "بررسی شده" : "بررسی نشده";
                warehouseCheckUp.personnelName = checkUp.PersonnelFullName;
                warehouseCheckUp.warehouseId = checkUp.WarehouseId;
                warehouseCheckUp.newLocations = checkUp.NewLocations;
                warehouseCheckUp.oldLocations = checkUp.Locations;
                warehouseCheckUp.checkTime = checkUp.CheckTime;
                warehouseCheckUp.comment = checkUp.Comment;
                warehouseCheckUp.hasComment = (stringIsNullOrEmpty(checkUp.Comment) == false);
                return warehouseCheckUp;
            }))
            return new PaginationInfo(serverResult.PaginationInfo.CurrentPage, serverResult.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0, 0);
        } finally {
            this.isLoading = false;
        }
    }


    async updateWarehouseCheckUpOpertators() {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('Complex/EnterpriseAdministrationServices/GetWarehouseCheckUpOperators', {
                IsForWarehouseManager: true
            });
            this.warehouseCheckUpOperators.update(...result.WarehouseCheckUpOperators.map(operator => {
                let warehouseCheckUpOperator = new WarehouseCheckUpOperator(this);
                warehouseCheckUpOperator.personnelId = operator.PersonnelId;
                warehouseCheckUpOperator.personnelFullName = operator.PersonnelFullName;
                warehouseCheckUpOperator.personnelCode = operator.PersonnelCode;
                warehouseCheckUpOperator.warehouseName = operator.WarehouseName;
                return warehouseCheckUpOperator;
            }))
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

    async clearWarehouseCheckUpOperatorFromOperators(warehouseOperator: WarehouseCheckUpOperator) {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('Complex/EnterpriseAdministrationServices/RemoveWarehouseCheckUpOperator', {
                PersonnelId: warehouseOperator.personnelId
            });
            if (result.IsSuccessful) {
                this.warehouseCheckUpOperators.remove(warehouseOperator);
            }
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

    async addWarehouseCheckUpOperatorIntoOperators(warehouseOperator: WarehouseCheckUpOperator) {
        try {
            this.isLoading = true;
            if (this.warehouseCheckUpOperators.some(wo => wo.personnelId == warehouseOperator.personnelId) == true) {
                await this.messageBoxConfirmWarning("این کارگر در لیست وجود دارد.", "تنظیم دسترسی");
                return;
            }
            let result = await ServerConnection.callServer('Complex/EnterpriseAdministrationServices/CreateWarehouseCheckUpOperator', {
                PersonnelId: warehouseOperator.personnelId
            });
            if (result.IsSuccessful) {
                this.warehouseCheckUpOperators.push(warehouseOperator);
            }
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

    async exportExcel() {
        try {
            this.isLoading = true;
            if (this.startDateTime == null) {
                await this.messageBoxConfirmWarning("تاریخ شروع انتخاب نشده است.", "بررسی دوره ای انبار");
                return;
            }
            let NUMBER_OF_RECORD = 1000000;
            let serverResult = await ServerConnection.callServer("Complex/WarehouseServices/GetManagerWarehouseCheckUps", {
                FilteringInformation: { "PaginationInfo": { "PageNo": 1, "PageSize": NUMBER_OF_RECORD }, "OrderInfo": [], "Filters": { "FilterString": "" } },
                HasTimePeriod: true,
                From: this.startDateTime,
                To: this.endDateTime
            });
            let converter = new Converters();
            let data = serverResult.WarehouseCheckUps.map((item, index) => {
                let result = {
                    'ردیف': index + 1,
                    'نفر': item.PersonnelFullName,
                    'تاریخ ایجاد': converter.onlyDateNoWeekDayPersianDateConverter(item.CreationTime),
                    'نام محصول': item.ProductName,
                    'کد محصول': item.ProductCode,
                    'شناسه محصول': item.ProductIndex ?? "",
                    'کشور': item.BrandName,
                    'نوع خودرو': item.CarModelName,
                    'رنگ': item.ColorName,
                    'نام انبار': item.WarehouseName,
                    'موجودی': item.Balance,
                    'لوکیشن': item.Locations,
                    'موجودی جدید': item.NewBalance,
                    'لوکیشن جدید': item.NewLocations,
                    'تاریخ بررسی': converter.onlyDateNoWeekDayPersianDateConverter(item.CheckTime)
                };
                return result;
            });
            new ExcelExporter().export('بررسی دوره ای انبار.xlsx', data);
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
}

export class WarehouseCheckUp extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: PeriodicWarehouseCheckUpForManagerViewModel) {
        super(parent);
    }

    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set index(v: number) { this._index = v; } public get index(): number { return this._index; } private _index: number;
    public set creationTime(v: moment.Moment) { this._creationTime = v; } public get creationTime(): moment.Moment { return this._creationTime; } private _creationTime: moment.Moment;
    public set personnelName(v: string) { this._personnelName = v; } public get personnelName(): string { return this._personnelName; } private _personnelName: string;
    public set productName(v: string) { this._productName = v; } public get productName(): string { return this._productName; } private _productName: string;
    public set productCode(v: string) { this._productCode = v; } public get productCode(): string { return this._productCode; } private _productCode: string;
    public set productIndex(v: string) { this._productIndex = v; } public get productIndex(): string { return this._productIndex;} private _productIndex: string;
    public set carModelName(v: string) { this._carModelName = v; } public get carModelName(): string { return this._carModelName; } private _carModelName: string;
    public set brandName(v: string) { this._brandName = v; } public get brandName(): string { return this._brandName; } private _brandName: string;
    public set countryName(v: string) { this._countryName = v; } public get countryName(): string { return this._countryName; } private _countryName: string;
    public set warehouseId(v: string) { this._warehouseId = v; } public get warehouseId(): string { return this._warehouseId; } private _warehouseId: string;
    public set warehouseName(v: string) { this._warehouseName = v; } public get warehouseName(): string { return this._warehouseName; } private _warehouseName: string;
    public set balance(v: number) { this._balance = v; } public get balance(): number { return this._balance; } private _balance: number;
    public set newBalance(v: number) { this._newBalance = v; } public get newBalance(): number { return this._newBalance; } private _newBalance: number;
    public set colorName(v: string) { this._colorName = v; } public get colorName(): string { return this._colorName; } private _colorName: string;
    public set oldLocations(v: string) { this._oldLocations = v; } public get oldLocations(): string { return this._oldLocations; } private _oldLocations: string;
    public set newLocations(v: string) { this._newLocations = v; } public get newLocations(): string { return this._newLocations; } private _newLocations: string;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set status(v: string) { this._status = v; } public get status(): string { return this._status; } private _status: string;
    public set checkTime(v: moment.Moment) { this._checkTime = v; } public get checkTime(): moment.Moment { return this._checkTime;} private _checkTime: moment.Moment;
    public set comment(v: string) { this._comment = v; } public get comment(): string { return this._comment;} private _comment: string;
    public set hasComment(v: boolean) { this._hasComment = v; } public get hasComment(): boolean { return this._hasComment;} private _hasComment: boolean;

}

export class WarehouseCheckUpOperator extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: PeriodicWarehouseCheckUpForManagerViewModel) {
        super(parent);
        this._parent = parent;
    }

    private _parent: PeriodicWarehouseCheckUpForManagerViewModel;
    public set personnelId(v: string) { this._personnelId = v; } public get personnelId(): string { return this._personnelId; } private _personnelId: string;
    public set personnelCode(v: string) { this._personnelCode = v; } public get personnelCode(): string { return this._personnelCode; } private _personnelCode: string;
    public set personnelFullName(v: string) { this._personnelFullName = v; } public get personnelFullName(): string { return this._personnelFullName; } private _personnelFullName: string;
    public set warehouseName(v: string) { this._warehouseName = v; } public get warehouseName(): string { return this._warehouseName; } private _warehouseName: string;

    async ClearFromOperators() {
        await this._parent.clearWarehouseCheckUpOperatorFromOperators(this);
    }

    async SetAsOperator() {
        await this._parent.addWarehouseCheckUpOperatorIntoOperators(this);
    }
}